var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteDatasetLoaded)?_c('TeaserArticlesHome',{attrs:{"headline":_vm.headline,"overview-page-url":_vm.overviewPageUrl,"show-loading-animation":_vm.showLoadingAnimation,"teasers":_vm.teasers}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }